import { Fill, Stroke, Style, Circle as CircleStyle, Icon } from 'ol/style';
import Text from 'ol/style/Text';

import * as olHas from 'ol/has';
const canvasHatchPattern = (() => {
    var pixelRatio;
    var p;
    var pctx;
    var x0 = 36;
    var x1 = -4;
    var y0 = -2;
    var y1 = 18;
    var offset = 32;

    pixelRatio = olHas.DEVICE_PIXEL_RATIO;
    p = document.createElement('canvas');
    p.width = 32 * pixelRatio;
    p.height = 16 * pixelRatio;
    pctx = p.getContext('2d');

    pctx.strokeStyle = '#000000';
    pctx.lineWidth = 1;
    pctx.beginPath();
    pctx.moveTo(x0, y0);
    pctx.lineTo(x1, y1);
    pctx.moveTo(x0 - offset, y0);
    pctx.lineTo(x1 - offset, y1);
    pctx.moveTo(x0 + offset, y0);
    pctx.lineTo(x1 + offset, y1);
    pctx.stroke();

    return pctx.createPattern(p, 'repeat');
})();

const guide = new Style({
    stroke: new Stroke({
        color: '#000080',
        width: 7
    })
});
const outline = new Style({
    stroke: new Stroke({
        color: '#000',
        width: 0.5
        // lineDash: [2, 4],
    })
});
const outlineThick = new Style({
    stroke: new Stroke({
        color: '#000',
        width: 2
        // lineDash: [2, 4],
    })
});
const outlineExtent = new Style({
    stroke: new Stroke({
        color: '#5992e1',
        width: 4,
        lineDash: [10, 5]
    })
});
const outlineExtentTwo = new Style({
    stroke: new Stroke({
        color: 'navy',
        width: 4,
        lineDash: [10, 5]
    })
});

const outlineHHS = new Style({
    stroke: new Stroke({
        color: '#ff5200',
        width: 7
    })
});

const outlineHHSlow = new Style({
    stroke: new Stroke({
        color: '#ff5200',
        width: 3
    })
});

const outlineRegion = new Style({
    stroke: new Stroke({
        color: '#daa520',
        width: 6
    })
});

const outlineRegionLow = new Style({
    stroke: new Stroke({
        color: '#daa520',
        width: 5
    })
});

const outlineState = new Style({
    stroke: new Stroke({
        color: '#000',
        width: 3
    })
});

const outlineStateLow = new Style({
    stroke: new Stroke({
        color: '#000',
        width: 2
    })
});

const outlineCounty = new Style({
    stroke: new Stroke({
        color: '#000',
        width: 2
    })
});
const outlineCountyLow = new Style({
    stroke: new Stroke({
        color: '#000',
        width: 1
    })
});

const outlineCensus = new Style({
    stroke: new Stroke({
        color: '#000',
        width: 1
        // lineDash: [2, 4],
    })
});

const outlineFeatureHighlightCensus = new Style({
    stroke: new Stroke({
        color: '#0e5eaa',
        width: 3
    })
});
const outlineFeatureHighlightCounty = new Style({
    stroke: new Stroke({
        color: '#00695b',
        width: 3
    })
});

//Convert A hex, rgb, or pattern value to a open layers style
const flatColorStyle = (color) => {
    return new Style({
        fill: new Fill({ color }),
        stroke: new Stroke({ color: '#000', width: 0.5 })
    });
};
const flatColorCountyStyle = (color, low = false) => {
    return new Style({
        fill: new Fill({ color }),
        stroke: new Stroke({
            color: low ? '#000' : '#000',
            width: low ? 0.5 : 1
        })
    });
};
const flatColorHoverStyle = (color) => {
    return new Style({
        fill: new Fill({ color }),
        stroke: new Stroke({ color: '#000', width: 4 })
    });
};
const poiCircle = (val, color = '#808080') => {
    return val > 10
        ? `<svg class="circle-svg" xmlns="http://www.w3.org/2000/svg" fill="#fff" width="40" height="40" version="1.1">
            <circle fill="${color}" cx="20" cy="20" r="20" />
            <text text-anchor="middle" fill="black" x="20" y="25" style="font: bold 15px sans-serif;color:'black'">${val}</text>
        </svg>`
        : `<svg class="circle-svg expand" xmlns="http://www.w3.org/2000/svg" fill="#fff" width="40" height="40" version="1.1">
            <circle fill="${color}" stroke="black" stroke-width="2" cx="20" cy="20" r="18" />
            <text text-anchor="middle" fill="black" x="20" y="22" style="font: bold 15px sans-serif;color:'black'">${val}</text>
            <circle fill="#000" cx="20" cy="30" r="6" /><line x1="16.8" x2="20.6" y1="28" y2="32" stroke="white" stroke-width="1.5" /> <line x1="22.8" x2="19.6" y1="28" y2="32" stroke="white" stroke-width="1.5" />
        </svg>`;
};
export { poiCircle };

const circleStyle = (val, size, color, textColor = '#000000', offset = 'center') => {
    const distance = 10;
    const centerCoord = [20, 20];
    const offsets = {
        center: centerCoord,
        left: [centerCoord[0] + distance * -1, centerCoord[1]],
        top: [centerCoord[0], centerCoord[1] + distance * -1],
        right: [centerCoord[0] + distance * +1, centerCoord[1]],
        bottom: [centerCoord[0], distance * +1 + centerCoord[1]]
    };
    const selectedOffset = offsets[offset];
    return new Style({
        image: new Icon({
            opacity: 1,
            src: 'data:image/svg+xml;utf8,' + encodeURIComponent(poiCircle(val, color)),
            scale: (1 / 40) * size,
            anchorXUnits: 'pixels',
            anchorYUnits: 'pixels',
            anchor: selectedOffset
        })
    });
};

const iconStyle = (pic, color, val) => {
    return new Style({
        image: new Icon({
            anchor: [0.5, 46],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            opacity: 1,
            scale: 0.8,
            src: pic,
            color: color + ''
        })
    });
};
const hhsLabelStyle = (val, highlight = false, offset = 'center') => {
    const distance = 20;
    const offsets = {
        center: [0, 0],
        left: [distance * -1, 0],
        top: [0, distance * -1],
        right: [distance * +1, 0],
        bottom: [0, distance * +1]
    };
    const selectedOffset = offsets[offset];
    return new Style({
        text: new Text({
            font: 'bold 16px "Montserrat", sans-serif',
            text: val + '',
            fill: new Fill({
                color: 'white'
            }),
            padding: [4, 4, 4, 4],
            backgroundFill: new Fill({
                color: highlight ? '#daa520' : '#ff5200'
            }),
            backgroundStroke: new Stroke({
                color: highlight ? '#b8860b' : '#c13e01',
                width: 4
            }),
            offsetX: 0 + selectedOffset[0],
            offsetY: 0 + selectedOffset[1] * -1,
            rotation: 0
        })
    });
};
export { hhsLabelStyle };

const noData = flatColorStyle(canvasHatchPattern);
// const outOfScope = flatColorStyle('red'); //wthis is the color for when svi data cannot be mapped to geometry due to error
const outOfScope = flatColorStyle('#cccccc'); //wthis is the color for when svi data cannot be mapped to geometry due to error
const undefinedData = flatColorStyle('#cccccc'); //wthis is the color for when svi data cannot be mapped to geometry due to error

export { outlineFeatureHighlightCensus, outlineFeatureHighlightCounty, outlineExtent, outlineExtentTwo, canvasHatchPattern, outlineCensus, outlineThick, outlineRegion, outlineRegionLow, outlineState, outlineStateLow, outlineHHS, outlineHHSlow, outlineCounty, outlineCountyLow, guide, outline, noData, outOfScope, undefinedData, flatColorStyle, flatColorCountyStyle, flatColorHoverStyle, circleStyle, iconStyle };
